import { Breadcrumb, Col, Row, Table, Typography, Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import React, { useRef } from 'react';
import { CSVLink } from 'react-csv';

const NamingReport = props => {
  const csvLink = useRef(null);
  const dataSource = [
    {
      key: '1',
      category: 'XRF',
      field: [
        { key: '1', name: 'XRF' },
        { key: '2', name: 'Signature Graph' },
      ],
      format: [
        {
          key: '1',
          name: 'AcquisitionID.xrf.csv',
        },
        {
          key: '2',
          name: 'AcquisitionID.siggraph.jpeg/jpg/pdf/png',
        },
      ],
    },
    {
      key: '2',
      category: 'Micrometer',
      field: [
        { key: '1', name: 'Photo' },
        { key: '2', name: 'Mount' },
        { key: '3', name: 'Bag' },
      ],
      format: [
        {
          key: '1',
          name: 'AcquisitionID.photo.xls',
        },
        {
          key: '2',
          name: 'AcquisitionID.mount.xls ',
        },
        {
          key: '3',
          name: 'AcquisitionID.bag.xls',
        },
      ],
    },
    {
      key: '3',
      category: 'Glossmeter',
      field: [{ key: '1', name: 'Glossmeter' }],
      format: [
        {
          key: '1',
          name: 'AcquisitionID.gloss.xls',
        },
      ],
    },
    {
      key: '4',
      category: 'Photospectrometer',
      field: [
        { key: '1', name: 'Dmin Oba' },
        { key: '2', name: 'Dmin Lab' },
        { key: '3', name: 'Dmin Spectrum' },
        { key: '4', name: 'Dmax Oba' },
        { key: '5', name: 'Dmax Lab' },
        { key: '6', name: 'dmax Spectrum' },
        { key: '7', name: 'Light Gray Oba' },
        { key: '8', name: 'Light Gray Lab' },
        { key: '9', name: 'Light Gray Spectrum' },
        { key: '10', name: 'Medium Gray  Oba' },
        { key: '11', name: 'Medium Gray Lab' },
        { key: '12', name: 'Medium Gray Spectrum' },
      ],
      format: [
        {
          key: '1',
          name: 'AcquisitionID.dmin.oba.csv',
        },
        {
          key: '2',
          name: 'AcquisitionID.dmin.lab.txt',
        },
        {
          key: '3',
          name: 'AcquisitionID.dmin.spectrum.txt',
        },
        {
          key: '4',
          name: 'AcquisitionID.dmax.oba.csv ',
        },
        {
          key: '5',
          name: 'AcquisitionID.dmax.lab.txt',
        },
        {
          key: '6',
          name: 'AcquisitionID.dmax.spectrum.txt',
        },
        {
          key: '7',
          name: 'AcquisitionID.lg.oba.csv',
        },
        {
          key: '8',
          name: 'AcquisitionID.lg.lab.txt',
        },
        {
          key: '9',
          name: 'AcquisitionID.lg.spectrum.txt',
        },
        {
          key: '10',
          name: 'AcquisitionID.mg.oba.csv',
        },
        {
          key: '11',
          name: 'AcquisitionID.mg.lab.txt',
        },
        {
          key: '12',
          name: 'AcquisitionID.mg.spectrum.txt',
        },
      ],
    },
    {
      key: '5',
      category: 'Mount Characteristics',
      field: [
        { key: '1', name: 'Mount Recto Texture' },
        { key: '2', name: 'Mount Verso Texture' },
        { key: '3', name: 'Mount Edge' },
        { key: '4', name: 'Mount Branding' },
      ],
      format: [
        {
          key: '1',
          name: 'AcquisitionID.mount.recto.texture.jpeg/jpg/png',
        },
        {
          key: '2',
          name: 'AcquisitionID.mount.verso.texture.jpeg/jpg/png',
        },
        {
          key: '3',
          name: 'AcquisitionID.mount.edge.jpeg/jpg/png',
        },
        {
          key: '4',
          name: 'AcquisitionID.mount.branding.jpeg/jpg/png',
        },
      ],
    },
    {
      key: '6',
      category: 'Basic Photos',
      field: [
        { key: '1', name: 'Print only' },
        { key: '2', name: 'Print only small' },
        { key: '3', name: 'Print and Mount Recto' },
        { key: '4', name: 'Mount Verso' },
        { key: '5', name: 'Signature Recto' },
        { key: '6', name: 'Signature Verso' },
        { key: '7', name: 'Annotations Recto 1' },
        { key: '8', name: 'Annotations Verso 1' },
        { key: '9', name: 'Stamp Verso 1' },
      ],
      format: [
        {
          key: '1',
          name: 'AcquisitionID.print.image.jpeg/jpg/png',
        },
        {
          key: '2',
          name: 'AcquisitionID.print.thumb.jpeg/jpg/png ',
        },
        {
          key: '3',
          name: 'AcquisitionID.pm.recto.jpeg/jpg/png',
        },
        {
          key: '4',
          name: 'AcquisitionID.pm.verso.jpeg/jpg/png',
        },
        {
          key: '5',
          name: 'AcquisitionID.signature.recto.jpeg/jpg/png',
        },
        {
          key: '6',
          name: 'AcquisitionID.signature.verso.jpeg/jpg/png',
        },
        {
          key: '7',
          name: 'annotations.recto.jpeg/jpg/png',
        },
        {
          key: '8',
          name: 'annotations.verso.jpeg/jpg/png',
        },
        {
          key: '9',
          name: 'stamp.verso.jpeg/jpg/png',
        },
        {
          key: '10',
          name: 'image.detail.jpeg/jpg/png',
        },
      ],
    },
  ];
  const columns = [
    {
      title: 'S.No.',
      dataIndex: 'key',
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
    },
    {
      title: 'Field Name',
      dataIndex: 'field',
      key: 'field',
      render: field => field.map(({ key, name }) => <div key={key}>{name}</div>),
    },
    {
      title: 'Format',
      dataIndex: 'format',
      key: 'format',
      render: format => format.map(({ key, name }) => <div key={key}>{name}</div>),
    },
  ];
  const csvData = dataSource.map(item => {
    return {
      Category: item.category,
      Field: item.field.map(field => field.name).join('\n'),
      Format: item.format.map(format => format.name).join('\n'),
    };
  });

  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Reports", href: "/reports/cataloging-report/naming-convention-report" }, { title: "Cataloging Report", href: "/reports/cataloging-report/naming-convention-report" }, { title: "Naming Convention Report" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={18}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                Naming Convention
              </Typography.Title>
            </Col>
            <Col xs={6} justify="end">
              <CSVLink ref={csvLink} data={csvData} filename={`naming_convention_report.csv`} onClick={() => {}}>
                <Button icon={<DownloadOutlined />} className="align-right" type="primary" size="small">
                  Download Csv
                </Button>
              </CSVLink>
            </Col>
          </Row>
        </div>
        <hr />
        <div className="artist-list">
          <Table className="no-fixed-last-col" scroll={{ x: 'max-content' }} columns={columns} bordered dataSource={dataSource} />
        </div>
      </Col>
    </Row>
  );
};

export default NamingReport;
